<script setup>
import { ref, reactive } from 'vue';
import TabNavigator from "@/Shared/Navigation/TabNavigator";
import ContactPanner from "@/Shared/ContactPanner";
import RainbooIcon from "@/Shared/SVG/RainbooIcon";
import ReasonCards from "@/Shared/ReasonCards";

let props = defineProps({
    data: Object,
});

let tabNavigation = [
    { name: 'Build', href: route('platform.build'), current: false },
    { name: 'APIs', href: route('platform.apis'), current: true },
    { name: 'Nodes', href: route('platform.nodes'), current: false },
];

</script>

<template>
    <div class="w-full relative">
        <TabNavigator :tabs="tabNavigation" />
        <h1 class="text-white text-3xl font-bold mt-12 sm:mt-16 text-center px-2 max-w-lg m-auto font-bold">{{data.title}}</h1>
        <div class="mt-28 sm:mt-20 mb-40 relative">
            <div class="flex flex-col sm:grid grid-cols-12">
                <div class="mb-10 col-span-12">
                    <h2 class="text-white text-[26px] font-bold">{{data.section_1.title}}</h2>
                    <div class="mt-6 grid grid-cols-1 lg:grid-cols-3 gap-5">
                        <div><p class="text-white text-opacity-60">{{data.section_1.paragraph_1}}</p></div>
                        <div><p class="text-white text-opacity-60">{{data.section_1.paragraph_2}}</p></div>
                        <div><p class="text-white text-opacity-60">{{data.section_1.paragraph_3}}</p></div>
                    </div>
                </div>
                <div class=" col-span-12">
                    <img class="rounded-2xl w-full max-w-[1024px] max-h-[440px] m-auto" :src="data.section_1.image" :alt="data.title" />
                </div>
            </div>
            <!--            -->
            <div class="mt-10 grid grid-cols-12">
                <div class="col-start-2 col-span-10 col-end-12">
                    <div class="flex flex-col lg:flex-row justify-start lg:space-x-10 space-y-6 lg:space-y-0 items-center">
                        <div class="w-full">
                            <h2 class="text-white text-[26px] font-bold mb-6">{{data.section_2.title}}</h2>
                            <p class="text-white text-opacity-60">{{data.section_2.content}}</p>
                        </div>
                        <div class="w-full"><img class="rounded-2xl w-full max-w-[490px] m-auto" :src="data.section_2.image" :alt="data.section_2.title" /></div>
                    </div>
                </div>
            </div>
            <!--            -->
            <div class="mt-20 w-full border-b border-wgn-purple-4">
                <RainbooIcon class="m-auto"/>
            </div>
            <div class="mt-3">
                <h2 class="text-white text-[22px] mb-7 text-center">{{data.section_3.title}}</h2>
                <ReasonCards :cards="data.section_3.cards"></ReasonCards>
            </div>
            <!--            -->
            <div class="mt-20 w-full border-b border-wgn-purple-4">
                <RainbooIcon class="m-auto"/>
            </div>
            <div class="mt-3">
                <h2 class="text-white text-[22px] mb-7 text-center">{{data.section_4.title}}</h2>
                <p class="text-white text-center mt-16">{{data.section_4.content}}</p>
                <div class="w-full mt-5">
                    <img class="rounded-2xl w-full m-auto" :src="data.section_4.image" :alt="data.title" />
                </div>
            </div>
            <!--            -->
            <div class="mt-20">
                <ContactPanner></ContactPanner>
            </div>
        </div>

    </div>
</template>
